const itemCounts = [25, 50, 75, 100];

const TABLE_ROWCOUNT_OPTIONS = itemCounts.map((el) => {
  return {
    label: el,
    value: el
  };
});

const ALL_TABLES = {
  tax: 'taxTable',
  serviceCatalog: 'serviceCatalogTable',
  allRequestors: 'allRequestorsTable',
  clients: 'clientsTable',
  clientRequestors: 'clientRequestorsTable',
  contractTemplate: 'contractTemplateTable',
  allContractsTemplate: 'allContractsTemplate',
  clientContractTemplate: 'clientContractTemplate',
  invoiceAudit: 'invoiceAuditTable',
  invoice: 'invoiceTable',
  conversations: 'conversationsTable',
  unknownEmailTickets: 'unknownEmailTicketsTable',
  sideConversationList: 'sideConversationList',
  tasks: 'taskTable',
  tickets: 'ticketTable',
  quote: 'quoteTable',
  assetPatches: 'assetPatchesTable',
  clientTickets: 'clientTickets',
  assetCpu: 'assetCpuTable',
  assetBitLocker: 'assetBitLockerTable',
  assetMemory: 'assetMemoryTable',
  asset: 'assetTable',
  patchInlineAsset: 'patchInlineAssetTable',
  assetClass: 'assetClassTable',
  settingsItDoc: 'settingsItDocTable',
  itDocumentation: 'itDocumentationTable',
  itDocAssociate: 'itDocAssociateTable',
  scripts: 'scriptsTable',
  communityScripts: 'communityScriptsTable',
  assetDetailsManageSoftware: 'assetDetailsManageSoftwareTable',
  assetDetailsSoftware: 'assetDetailsSoftwareTable',
  assetDetailsAllProcess: 'assetDetailsAllProcessTable',
  dataReportTable: 'dataReportTable',
  alert: 'alertTable',
  assetAlert: 'assetAlert',
  pdfHistory: 'pdfHistoryTable',
  patch: 'patchTable',
  associateItDocumentation: 'associateItDocumentationTable',
  networkListTable: 'networkListTable',
  scannedAssetListTable: 'scannedAssetListTable',
  manageTechnician: 'manageTechnician',
  allMonitorAssetTable: 'allMonitorAssetTable',
  allEmployeeTable: 'allEmployeeTable',
  manageAsset: 'manageAsset',
  fileExplorer: 'fileExplorer',
  department: 'department',
  sitelist: 'sitelist',
  executedScriptList: 'executedScriptList',
  customSoftwareList: 'customSoftwareList',
  kbListTable: 'kbListTable',
  kbFeedbackTable: 'kbFeedbackTable',
  assetRuleList: 'assetRuleList',
  clientDeviceCategory: 'clientDeviceCategory',
  paymentList: 'paymentList',
  requesterGroups: 'requesterGroupsTable',
  projectTable: 'projectTable',
  productsAndServicesTable: 'productsAndServicesTable',
  taxTable: 'taxTable',
  ticketSchedulerTable: 'ticketSchedulerTable',
  retainerSummaryReportTable: 'retainerSummaryReportTable',
  detailedConsumptionReportTable: 'detailedConsumptionReportTable',
  invoiceStatementsTable: 'invoiceStatementsTable',
  runBooksTable: 'runBooksTable',
  bouncedEmailsTable: 'bouncedEmailsTable',
  customSoftwareTable: 'customSoftwareTable',
  defaultAssetClass: 'defaultAssetClass',
  customAssetClass: 'customAssetClass'
};

const DEFAULT_ROW_COUNT = {
  [ALL_TABLES.allRequestors]: 50,
  [ALL_TABLES.customSoftwareList]: 50,
  [ALL_TABLES.clients]: 50,
  [ALL_TABLES.clientRequestors]: 50,
  [ALL_TABLES.contractTemplate]: 50,
  [ALL_TABLES.allContractsTemplate]: 20,
  [ALL_TABLES.clientContractTemplate]: 20,
  [ALL_TABLES.invoiceAudit]: 20,
  [ALL_TABLES.invoice]: 50,
  [ALL_TABLES.conversations]: 50,
  [ALL_TABLES.sideConversationList]: 20,
  [ALL_TABLES.unknownEmailTickets]: 50,
  [ALL_TABLES.tasks]: 50,
  [ALL_TABLES.tickets]: 50,
  [ALL_TABLES.quote]: 50,
  [ALL_TABLES.assetPatches]: 25,
  [ALL_TABLES.clientTickets]: 50,
  [ALL_TABLES.assetCpu]: 50,
  [ALL_TABLES.assetBitLocker]: 50,
  [ALL_TABLES.assetMemory]: 50,
  [ALL_TABLES.asset]: 50,
  [ALL_TABLES.patchInlineAsset]: 50,
  [ALL_TABLES.assetClass]: 20,
  [ALL_TABLES.settingsItDoc]: 50,
  [ALL_TABLES.itDocumentation]: 50,
  [ALL_TABLES.itDocAssociate]: 50,
  [ALL_TABLES.scripts]: 50,
  [ALL_TABLES.communityScripts]: 50,
  [ALL_TABLES.assetDetailsManageSoftware]: 50,
  [ALL_TABLES.assetDetailsSoftware]: 50,
  [ALL_TABLES.assetDetailsAllProcess]: 50,
  [ALL_TABLES.dataReportTable]: 100,
  [ALL_TABLES.alert]: 50,
  [ALL_TABLES.assetAlert]: 50,
  [ALL_TABLES.pdfHistory]: 50,
  [ALL_TABLES.patch]: 50,
  [ALL_TABLES.associateItDocumentation]: 50,
  [ALL_TABLES.networkListTable]: 50,
  [ALL_TABLES.scannedAssetListTable]: 50,
  [ALL_TABLES.manageTechnician]: 50,
  [ALL_TABLES.allMonitorAssetTable]: 50,
  [ALL_TABLES.allEmployeeTable]: 50,
  [ALL_TABLES.manageAsset]: 50,
  [ALL_TABLES.fileExplorer]: 1000,
  [ALL_TABLES.department]: 200,
  [ALL_TABLES.sitelist]: 50,
  [ALL_TABLES.sitelist]: 50,
  [ALL_TABLES.executedScriptList]: 50,
  [ALL_TABLES.kbListTable]: 50,
  [ALL_TABLES.kbFeedbackTable]: 50,
  [ALL_TABLES.assetRuleList]: 50,
  [ALL_TABLES.clientDeviceCategory]: 50,
  [ALL_TABLES.paymentList]: 20,
  [ALL_TABLES.requesterGroups]: 50,
  [ALL_TABLES.projectTable]: 50,
  [ALL_TABLES.invoiceStatementsTable]: 50,
  [ALL_TABLES.runBooksTable]: 10,
  [ALL_TABLES.bouncedEmailsTable]: 50,
  [ALL_TABLES.customSoftwareTable]: 20,
  [ALL_TABLES.defaultAssetClass]: 50,
  [ALL_TABLES.customAssetClass]: 50
};

const ROW_COUNT = 50;

const getDefaultRowCount = (tableName) => {
  return DEFAULT_ROW_COUNT?.[tableName] || ROW_COUNT;
};

export {
  TABLE_ROWCOUNT_OPTIONS,
  ALL_TABLES,
  DEFAULT_ROW_COUNT,
  getDefaultRowCount
};
